import React, { useContext } from 'react'
import { IonContent, IonPage, useIonRouter, useIonViewWillEnter } from '@ionic/react'
import { CustomSpacer, DetailContent, StyleIonHeader, TextStyle } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'
import { alertCircleOutline, chatbubblesOutline, notificationsOutline, settingsOutline } from 'ionicons/icons'
import { DivideLine, DivideLineBold } from '../../../components/atoms/divide'
import { MainTitle, SubTitle } from '../components'
import { amountString } from '../../../common'

export const Main: React.FC = observer(() => {
  const { myStore, commonStore, authStore } = useContext(StoresContext)
  const detailStore = myStore.assetSummaryStore
  const router = useIonRouter()

  useIonViewWillEnter(() => {
    commonStore.setShowTab(true)
    detailStore.load(undefined, true)
    // FIXME : route 또는 store에서 통합 처리할 수 있도록 수정 필요
    setTimeout(() => {
      if (authStore.userInfo?.status === 'NEED_REQUIRE_DATA_INPUT') {
        router.push('/signUp')
      }
    }, 300)
  })

  return (
    <IonPage>
      <StyleIonHeader type={'MAIN'} title={'MY'} rightItem={'ALARM'} />
      <IonContent>
        <DetailContent detailStore={detailStore}>
          <MainTitle mainTitle={'총 보유 자산'} mainHref={'/myPage/asset'} />
          <CustomCard>
            <div>
              <TextStyle type={'b_20'} color={'primary_dark'}>
                {amountString(String(detailStore.content?.currentBalance || 0))}
              </TextStyle>
              <TextStyle type={'m_12'} color={'primary_dark'}>
                {' 원'}
              </TextStyle>
            </div>
            <StyleBox
              className={
                (myStore.balanceChangeRate as number) > 0
                  ? 'error_main'
                  : (myStore.balanceChangeRate as number) < 0
                  ? 'secondary_main'
                  : 'primary_light'
              }
            >
              <TextStyle type={'sb_13'}>
                {`${(myStore.balanceChangeRate as number) > 0 ? '+' : ''}${amountString(
                  String(myStore.balanceChangeRate || 0),
                  false,
                  1,
                )}%`}
              </TextStyle>
            </StyleBox>
          </CustomCard>
          <ContentWrap>
            <TextStyle type={'m_14'}>총 보유 조각 수량</TextStyle>
            <TextStyle type={'m_14'}>{amountString(String(detailStore.content?.totalCount || 0))} 개</TextStyle>
          </ContentWrap>
          <ContentWrap>
            <TextStyle type={'m_14'}>매각 현황 작품수</TextStyle>
            <TextStyle type={'m_14'}>{amountString(String(detailStore.content?.soldProductCount || 0))} 개</TextStyle>
          </ContentWrap>
          <CustomSpacer spacing="24px" />
          <DivideLineBold />
          <CustomSpacer spacing="8px" />
          <MainTitle
            mainTitle={'예치금'}
            buttons={[
              { title: '출금', backgroundColor: 'var(--ion-color-primary_main)', link: '/myPage/account/withdrawal' },
              { title: '충전', backgroundColor: 'var(--ion-color-secondary_main)', link: '/myPage/account/deposit' },
            ]}
            subTitle={`${amountString(String(detailStore.content?.cashBalance || 0))} 원`}
            subHref={'/myPage/account'}
          />
          <DivideLine isShort={true} />
          <CustomSpacer spacing="10px" />
          <ContentWrap>
            <TextStyle type={'m_14'}>거래 가능 금액</TextStyle>
            <TextStyle type={'m_14'}>{amountString(String(myStore.tradableBalance || 0))} 원</TextStyle>
          </ContentWrap>
          <ContentWrap>
            <TextStyle type={'m_14'}>매수 미체결 금액</TextStyle>
            <TextStyle type={'m_14'}>{amountString(String(detailStore.content?.lockedBalance || 0))} 원</TextStyle>
          </ContentWrap>
          <CustomSpacer spacing="24px" />
          <DivideLineBold />
          <TextWrap>
            <TextStyle type={'r_13'} color={'primary_light'}>
              고객센터
            </TextStyle>
          </TextWrap>
          <SubTitle icon={notificationsOutline} title={'공지사항'} href={'/myPage/notice'} />
          <DivideLine isShort={true} />
          <SubTitle icon={chatbubblesOutline} title={'1:1 문의'} href={'/myPage/qna'} />
          <DivideLine isShort={true} />
          <SubTitle icon={alertCircleOutline} title={'자주 묻는 질문'} href={'/myPage/faq'} />
          <DivideLine isShort={true} />
          <SubTitle icon={settingsOutline} title={'설정'} href={'/myPage/setting'} />
          <CustomSpacer spacing="50px" />
        </DetailContent>
      </IonContent>
    </IonPage>
  )
})

const CustomCard = styled.div`
  background-color: var(--ion-color-gray100);
  border-radius: 8px;
  margin: 0 20px 16px;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .error_main {
    background-color: var(--ion-color-error_main);
  }
  .secondary_main {
    background-color: var(--ion-color-secondary_main);
  }
  .primary_light {
    background-color: var(--ion-color-primary_light);
  }
`

const ContentWrap = styled.span`
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
`

const TextWrap = styled.div`
  margin: 24px 20px 8px;
`
const StyleBox = styled.div`
  border-radius: 4px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px 2px;
  color: #ffffff;
`
